var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('Menu',{attrs:{"isAdmin":_vm.isAdmin}})],1),_c('router-view',{on:{"userlogin":_vm.getUser}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }